var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTweet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.333 10.929 18.546 5H17.31l-4.528 5.147L9.17 5H5l5.466 7.784L5 19h1.235l4.779-5.436L14.83 19H19M6.68 5.911h1.897l8.733 12.223h-1.897"
})));
export default SvgTweet;